module.exports = __webpack_public_path__ + "static/media/dr-isioma-okobah-foundation-2017.b9911284.JPG";